import { VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import CDS from "design-system";
import {
  checkpointTemplatePathById,
  emailTemplatePathById,
  meetingTemplatePathById,
  messageTemplatePathById,
  taskTemplatePathById,
} from "helpers/url/pages/v2/actionPaths";
import { NoTemplatesToShow } from "components/EmptyComponents/RandomEmptyState";
import { ActionType } from "features/Resources/Shared/models";

const NEW_TEMPLATE_PATHS: Record<ActionType, (id: string) => string> = {
  email: emailTemplatePathById,
  message: messageTemplatePathById,
  task: taskTemplatePathById,
  meeting: meetingTemplatePathById,
  checkpoint: checkpointTemplatePathById,
};

interface TemplateListEmptyStateProps {
  actionType: ActionType;
  /** When the list is empty because of an active search/filter, show the plain "not found" state instead of the create CTA. */
  hasActiveFilters?: boolean;
}

export default function TemplateListEmptyState({ actionType, hasActiveFilters = false }: TemplateListEmptyStateProps) {
  const navigate = useNavigate();

  if (hasActiveFilters) return <NoTemplatesToShow />;

  return (
    <VStack py={12} spacing={3} textAlign="center">
      <CDS.Text18 fontWeight="bold">No {actionType} templates yet</CDS.Text18>
      <CDS.Text14 color="content.tertiary" maxW="440px">
        Templates you create appear here and can be added to paths.
      </CDS.Text14>
      <CDS.Button
        intent={CDS.Button.intent.indigo}
        variant={CDS.Button.variant.solid}
        size="sm"
        onClick={() => navigate(NEW_TEMPLATE_PATHS[actionType]("new"))}
      >
        Create your first {actionType} template
      </CDS.Button>
    </VStack>
  );
}
